import Column from '@app/components/layout/Column'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { Tabs } from '@app/components/core/tabs/Tabs'
import { match } from 'ts-pattern'
import { Overview } from './tab-content/Overview'
import { Initiatives } from './tab-content/Initiatives'
import useMediaQuery from '@app/util/useMediaQuery'
import { useParamState } from '@app/util/hooks/useParamState'
import { Thread } from '@app/components/blocks/thread/Thread'
import { ServiceProviderConceptViewModel } from 'functions/app/service-provider-concept/view'
import {
  serviceProviderConceptTabs,
  serviceProviderConceptTabsQueryParamName,
} from '../constants'

interface TabContentProps {
  serviceProviderConcept: ServiceProviderConceptViewModel
}

export const TabContent = ({ serviceProviderConcept }: TabContentProps) => {
  const [language, _] = useLanguage()
  const translations =
    i18n.languages[language].app.serviceProviderConceptPage.tabs
  const [tab, setTab] = useParamState(
    serviceProviderConceptTabs,
    serviceProviderConceptTabs.overview,
    serviceProviderConceptTabsQueryParamName,
  )
  const isMobile = useMediaQuery()
  const paddingRight = isMobile ? '0rem' : '4.75rem'

  return (
    <Column
      alignItems="stretch"
      gap={isMobile ? '1rem' : '2rem'}
      style={{ paddingRight: paddingRight }}
    >
      <Tabs.Group selectedTab={tab}>
        <Tabs.Tab
          label={translations.overview}
          tabKey={serviceProviderConceptTabs.overview}
          onSelectTab={setTab}
        />

        <Tabs.Tab
          label={translations.initiatives}
          tabKey={serviceProviderConceptTabs.initiatives}
          onSelectTab={setTab}
        />

        <Tabs.Tab
          label={translations.discussions}
          tabKey={serviceProviderConceptTabs.discussions}
          onSelectTab={setTab}
        />
      </Tabs.Group>
      {match(tab)
        .with(serviceProviderConceptTabs.overview, () => (
          <Overview
            key={serviceProviderConceptTabs.overview}
            serviceProviderConcept={serviceProviderConcept}
          />
        ))
        .with(serviceProviderConceptTabs.initiatives, () => (
          <Initiatives
            key={serviceProviderConceptTabs.initiatives}
            serviceProviderConcept={serviceProviderConcept}
          />
        ))
        .with(serviceProviderConceptTabs.discussions, () => (
          <Thread threadId={serviceProviderConcept.thread} />
        ))
        .exhaustive()}
    </Column>
  )
}
